import Button from '@components/button';
import { ButtonProps, Icon } from '@mis/sushi-tailwind-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const CompanyReserveButton: React.FC<ButtonProps> = (props) => {
  const { t } = useTranslation(['button']);
  return (
    <Button.Primary icon={<Icon name="check" />} data-testid="btnReserved" {...props}>
      {t('button:reserve')}
    </Button.Primary>
  );
};
